import type { ServerExperimentConfig } from './server'

/**
 * SERVER EXPERIMENTS CONFIGURATION
 *
 * Add server-assigned experiments here. Each entry auto-generates:
 * - get{Name}Assignment() - returns server-assigned treatment
 *
 * Navigation: getMyExperimentAssignment() → search for "myExperiment:"
 *
 * Note: Eligibility logic lives in facade-server's ManakinAssignmentService.scala
 *
 * Example:
 *   myServerExperiment: {
 *     id: 'my_server_experiment',
 *     variants: ['control', 'test'] as const,
 *   }
 */
export const serverExperimentsConfig = {
  toolsLtvExp3: {
    id: 'tools_ltv_exp_3',
    variants: ['control', 'limit_1', 'limit_2'] as const,
  },
} as const satisfies Record<string, ServerExperimentConfig>
